import { Box } from "@prismicio/editor-ui"
import { Suspense } from "react"

import {
  headerBottomMargin,
  SidePanel,
  sidePanelPadding,
} from "../documentLayout"
import { Locales } from "./Locales/Locales"
import { VersionPanel } from "./VersionPanel/VersionPanel"

export function RightSidePanel() {
  return (
    <SidePanel>
      <Suspense>
        <Box
          padding={{ top: headerBottomMargin, ...sidePanelPadding("right") }}
          overflowY="auto"
          flexDirection="column"
        >
          <Locales />
          <VersionPanel />
        </Box>
      </Suspense>
    </SidePanel>
  )
}
